import {
    ADDEDITUSER_SUCCESS,
    ADDEDITUSER_FAILED,
    RESET_ADDEDITUSER,
    LOADING_ADDEDITUSER,
    NETWORK_ERROR_ADDEDITUSER
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAddEditUser = () => {
    return { type: RESET_ADDEDITUSER };
};

const addEditUser = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDEDITUSER });
    await partnerServices
        .post("addUpdateUserMngt", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(addEditUsersuccess(res.data));
                    break;
                default:
                    dispatch(addEditUserFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADDEDITUSER,
                payload: err
            });
        });
};
function addEditUsersuccess(data) {
    return {
        type: ADDEDITUSER_SUCCESS,
        payload: data
    };
}
function addEditUserFailed(data) {
    return {
        type: ADDEDITUSER_FAILED,
        payload: data
    };
}

export { resetAddEditUser, addEditUser };
